import React, { useEffect } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  MenuItem,
  Select,
  InputLabel,
  FormControl,
} from "@mui/material";
import { useFormik } from "formik";
import * as Yup from "yup";
import { editTeamMemberApi } from "../../../api/adminApi/adminApi"; // ✅ Adjust if path differs
import { toast } from "react-toastify";

// ✅ Validation schema
const validationSchema = Yup.object({
  firstName: Yup.string().required("First Name is required"),
  lastName: Yup.string().required("Last Name is required"),
  email: Yup.string().email("Invalid email").required("Email is required"),
  role: Yup.string().required("User type is required"),
});

const EditTeamMemberModal = ({ open, handleClose, selectedUser, refreshList }) => {
  const formik = useFormik({
    initialValues: {
      firstName: "",
      lastName: "",
      email: "",
      role: "",
    },
    validationSchema,
    enableReinitialize: true,
    onSubmit: async (values) => {
      try {
        

        const res = await editTeamMemberApi(selectedUser._id,values);
        toast.success(res.data.message || "Team member updated!");
        refreshList(); // ⬅️ Fetch updated list
        handleClose(); // ⬅️ Close modal
      } catch (err) {
        toast.error(err?.response?.data?.message || "Failed to update.");
      }
    },
  });

  // ✅ Populate form when `selectedUser` changes
  useEffect(() => {
    if (selectedUser) {
      formik.setValues({
        firstName: selectedUser.firstName || "",
        lastName: selectedUser.lastName || "",
        email: selectedUser.email || "",
        role: selectedUser.role || "",
      });
    }
  }, [selectedUser]);

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
      <form onSubmit={formik.handleSubmit}>
        <DialogTitle>Edit Team Member</DialogTitle>
        <DialogContent dividers>
          <TextField
            label="First Name"
            name="firstName"
            fullWidth
            margin="dense"
            value={formik.values.firstName}
            onChange={formik.handleChange}
            error={formik.touched.firstName && Boolean(formik.errors.firstName)}
            helperText={formik.touched.firstName && formik.errors.firstName}
          />
          <TextField
            label="Last Name"
            name="lastName"
            fullWidth
            margin="dense"
            value={formik.values.lastName}
            onChange={formik.handleChange}
            error={formik.touched.lastName && Boolean(formik.errors.lastName)}
            helperText={formik.touched.lastName && formik.errors.lastName}
          />
          <TextField
            label="Email"
            name="email"
            fullWidth
            margin="dense"
            value={formik.values.email}
            onChange={formik.handleChange}
            error={formik.touched.email && Boolean(formik.errors.email)}
            helperText={formik.touched.email && formik.errors.email}
          />
          <FormControl fullWidth margin="dense">
            <InputLabel>User Type</InputLabel>
            <Select
              name="role"
              value={formik.values.role}
              onChange={formik.handleChange}
              error={formik.touched.role && Boolean(formik.errors.role)}
              label="User Type"
            >
              <MenuItem value="doctor">Doctor</MenuItem>
              <MenuItem value="staff">Staff</MenuItem>
              <MenuItem value="admin">Admin</MenuItem>
            </Select>
          </FormControl>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="secondary" variant="outlined">
            Cancel
          </Button>
          <Button type="submit" variant="contained" color="primary">
            Update
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  );
};

export default EditTeamMemberModal;
